/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

export const GET_CARBON_INTENSITY_BY_REGION_RESPONSE = {
	title: "Carbon Intensity by Country: Timeseries",
	lineSeries: [
		{
			name: "Finland",
			linePoints: [
				{
					name: "2024-11-25T11:00",
					value: 387.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-25T12:00",
					value: 389.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-25T13:00",
					value: 391.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-25T14:00",
					value: 388.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-25T15:00",
					value: 385.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-25T16:00",
					value: 384.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-25T17:00",
					value: 380.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-25T18:00",
					value: 380.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-25T19:00",
					value: 381.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-25T20:00",
					value: 381.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-25T21:00",
					value: 380.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-25T22:00",
					value: 380.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-25T23:00",
					value: 380.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-26T00:00",
					value: 383.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-26T01:00",
					value: 384.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-26T02:00",
					value: 383.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-26T03:00",
					value: 385.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-26T04:00",
					value: 384.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-26T05:00",
					value: 386.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-26T06:00",
					value: 386.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-26T07:00",
					value: 388.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-26T08:00",
					value: 388.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-26T09:00",
					value: 389.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-26T10:00",
					value: 391.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-26T11:00",
					value: 391.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-26T12:00",
					value: 388.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-26T13:00",
					value: 390.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-26T14:00",
					value: 388.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-26T15:00",
					value: 384.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-26T16:00",
					value: 383.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-26T17:00",
					value: 380.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-26T18:00",
					value: 380.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-26T19:00",
					value: 381.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-26T20:00",
					value: 381.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-26T21:00",
					value: 380.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-26T22:00",
					value: 380.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-26T23:00",
					value: 380.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-27T00:00",
					value: 383.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-27T01:00",
					value: 384.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-27T02:00",
					value: 383.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-27T03:00",
					value: 385.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-27T04:00",
					value: 384.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-27T05:00",
					value: 384.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-27T06:00",
					value: 388.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-27T07:00",
					value: 388.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-27T08:00",
					value: 388.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-27T09:00",
					value: 389.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-27T10:00",
					value: 390.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-27T11:00",
					value: 392.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-27T12:00",
					value: 391.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-27T13:00",
					value: 390.0,
					unit: "gCO2eq/Kwh"
				},
				{
					name: "2024-11-27T14:00",
					value: 388.0,
					unit: "gCO2eq/Kwh"
				}
			]
		}
	]
};

export const GET_AVERAGE_CARBON_INTENISTY_RESPONSE = {
	title: "Average Intensity by Region",
	barSeries: [
		{
			name: "Regions not used by the customer",
			bars: [
				{ name: "SE", value: 50, unit: "kgCO2e/kWh" },
				{ name: "FR", value: 60, unit: "kgCO2e/kWh" },
				{ name: "NO", value: 70, unit: "kgCO2e/kWh" },
				{ name: "BE", value: 80, unit: "kgCO2e/kWh" },
				{ name: "FI", value: 79.38, unit: "kgCO2e/kWh" },
				{ name: "DK", value: 100, unit: "kgCO2e/kWh" },
				{ name: "PT", value: 120, unit: "kgCO2e/kWh" },
				{ name: "UK", value: 150, unit: "kgCO2e/kWh" },
				{ name: "ES", value: 170, unit: "kgCO2e/kWh" },
				{ name: "LT", value: 200, unit: "kgCO2e/kWh" },
				{ name: "NL", value: 220, unit: "kgCO2e/kWh" },
				{ name: "LV", value: 230, unit: "kgCO2e/kWh" },
				{ name: "DE", value: 250, unit: "kgCO2e/kWh" },
				{ name: "AT", value: 270, unit: "kgCO2e/kWh" },
				{ name: "SK", value: 290, unit: "kgCO2e/kWh" },
				{ name: "HU", value: 310, unit: "kgCO2e/kWh" },
				{ name: "IE", value: 0, unit: "kgCO2e/kWh" },
				{ name: "SE", value: 0, unit: "kgCO2e/kWh" },
				{ name: "RO", value: 0, unit: "kgCO2e/kWh" },
				{ name: "ITA", value: 0, unit: "kgCO2e/kWh" },
				{ name: "EL", value: 450, unit: "kgCO2e/kWh" },
				{ name: "PL", value: 500, unit: "kgCO2e/kWh" },
				{ name: "AECI", value: 10, unit: "kgCO2e/kWh" },
				{ name: "AESO", value: 17, unit: "kgCO2e/kWh" },
				{ name: "AVA", value: 31, unit: "kgCO2e/kWh" },
				{ name: "AZPS", value: 38, unit: "kgCO2e/kWh" },
				{ name: "BANC", value: 45, unit: "kgCO2e/kWh" },
				{ name: "BCHYDRO", value: 52, unit: "kgCO2e/kWh" },
				{ name: "BPA", value: 66, unit: "kgCO2e/kWh" },
				{ name: "CAISO", value: 73, unit: "kgCO2e/kWh" },
				{ name: "CHPD", value: 80, unit: "kgCO2e/kWh" },
				{ name: "CPLE", value: 87, unit: "kgCO2e/kWh" },
				{ name: "CPLW", value: 94, unit: "kgCO2e/kWh" },
				{ name: "DOPD", value: 122, unit: "kgCO2e/kWh" },
				{ name: "DUK", value: 129, unit: "kgCO2e/kWh" },
				{ name: "ELE", value: 143, unit: "kgCO2e/kWh" },
				{ name: "ERCOT", value: 150, unit: "kgCO2e/kWh" },
				{ name: "FMPP", value: 171, unit: "kgCO2e/kWh" },
				{ name: "FPC", value: 178, unit: "kgCO2e/kWh" },
				{ name: "FPL", value: 185, unit: "kgCO2e/kWh" },
				{ name: "GCPD", value: 199, unit: "kgCO2e/kWh" },
				{ name: "GR", value: 206, unit: "kgCO2e/kWh" },
				{ name: "GVL", value: 213, unit: "kgCO2e/kWh" },
				{ name: "HQ", value: 220, unit: "kgCO2e/kWh" },
				{ name: "HST", value: 227, unit: "kgCO2e/kWh" },
				{ name: "IESO", value: 248, unit: "kgCO2e/kWh" },
				{ name: "IID", value: 255, unit: "kgCO2e/kWh" },
				{ name: "IPCO", value: 262, unit: "kgCO2e/kWh" },
				{ name: "ISONE", value: 269, unit: "kgCO2e/kWh" },
				{ name: "IT", value: 276, unit: "kgCO2e/kWh" },
				{ name: "JEA", value: 283, unit: "kgCO2e/kWh" },
				{ name: "LDWP", value: 290, unit: "kgCO2e/kWh" },
				{ name: "LGEE", value: 297, unit: "kgCO2e/kWh" },
				{ name: "MISO", value: 318, unit: "kgCO2e/kWh" },
				{ name: "MPCO", value: 325, unit: "kgCO2e/kWh" },
				{ name: "NEM_NSW", value: 332, unit: "kgCO2e/kWh" },
				{ name: "NEM_QLD", value: 339, unit: "kgCO2e/kWh" },
				{ name: "NEM_SA", value: 346, unit: "kgCO2e/kWh" },
				{ name: "NEM_TAS", value: 353, unit: "kgCO2e/kWh" },
				{ name: "NEM_VIC", value: 360, unit: "kgCO2e/kWh" },
				{ name: "NEVP", value: 367, unit: "kgCO2e/kWh" },
				{ name: "NYISO", value: 388, unit: "kgCO2e/kWh" },
				{ name: "PACE", value: 395, unit: "kgCO2e/kWh" },
				{ name: "PACW", value: 402, unit: "kgCO2e/kWh" },
				{ name: "PGE", value: 409, unit: "kgCO2e/kWh" },
				{ name: "PJM", value: 416, unit: "kgCO2e/kWh" },
				{ name: "PNM", value: 430, unit: "kgCO2e/kWh" },
				{ name: "PSCO", value: 437, unit: "kgCO2e/kWh" },
				{ name: "PSEI", value: 444, unit: "kgCO2e/kWh" },
				{ name: "RS", value: 465, unit: "kgCO2e/kWh" },
				{ name: "SC", value: 472, unit: "kgCO2e/kWh" },
				{ name: "SCEG", value: 479, unit: "kgCO2e/kWh" },
				{ name: "SCL", value: 486, unit: "kgCO2e/kWh" },
				{ name: "SEC", value: 500, unit: "kgCO2e/kWh" },
				{ name: "SOCO", value: 521, unit: "kgCO2e/kWh" },
				{ name: "SPA", value: 528, unit: "kgCO2e/kWh" },
				{ name: "SPP", value: 535, unit: "kgCO2e/kWh" },
				{ name: "SRP", value: 542, unit: "kgCO2e/kWh" },
				{ name: "TAL", value: 549, unit: "kgCO2e/kWh" },
				{ name: "TEC", value: 556, unit: "kgCO2e/kWh" },
				{ name: "TEPC", value: 563, unit: "kgCO2e/kWh" },
				{ name: "TID", value: 570, unit: "kgCO2e/kWh" },
				{ name: "TPWR", value: 577, unit: "kgCO2e/kWh" },
				{ name: "TVA", value: 584, unit: "kgCO2e/kWh" },
				{ name: "WACM", value: 598, unit: "kgCO2e/kWh" },
				{ name: "WALC", value: 605, unit: "kgCO2e/kWh" },
				{ name: "WAUW", value: 12, unit: "kgCO2e/kWh" },
				{ name: "WEM", value: 19, unit: "kgCO2e/kWh" }
			]
		},
		{
			name: "Regions used by the customer",
			bars: [
				{ name: "SE", value: 0, unit: "kgCO2e/kWh" },
				{ name: "FR", value: 0, unit: "kgCO2e/kWh" },
				{ name: "NO", value: 0, unit: "kgCO2e/kWh" },
				{ name: "BE", value: 0, unit: "kgCO2e/kWh" },
				{ name: "FI", value: 0, unit: "kgCO2e/kWh" },
				{ name: "DK", value: 0, unit: "kgCO2e/kWh" },
				{ name: "PT", value: 0, unit: "kgCO2e/kWh" },
				{ name: "UK", value: 0, unit: "kgCO2e/kWh" },
				{ name: "ES", value: 0, unit: "kgCO2e/kWh" },
				{ name: "LT", value: 0, unit: "kgCO2e/kWh" },
				{ name: "NL", value: 0, unit: "kgCO2e/kWh" },
				{ name: "LV", value: 0, unit: "kgCO2e/kWh" },
				{ name: "DE", value: 0, unit: "kgCO2e/kWh" },
				{ name: "AT", value: 0, unit: "kgCO2e/kWh" },
				{ name: "SK", value: 0, unit: "kgCO2e/kWh" },
				{ name: "HU", value: 0, unit: "kgCO2e/kWh" },
				{ name: "IE", value: 330, unit: "kgCO2e/kWh" },
				{ name: "SE", value: 340, unit: "kgCO2e/kWh" },
				{ name: "RO", value: 350, unit: "kgCO2e/kWh" },
				{ name: "ITA", value: 370, unit: "kgCO2e/kWh" },
				{ name: "EL", value: 0, unit: "kgCO2e/kWh" },
				{ name: "PL", value: 0, unit: "kgCO2e/kWh" },
				{ name: "AECI", value: 0, unit: "kgCO2e/kWh" },
				{ name: "AESO", value: 0, unit: "kgCO2e/kWh" },
				{ name: "AT", value: 0, unit: "kgCO2e/kWh" },
				{ name: "AVA", value: 0, unit: "kgCO2e/kWh" },
				{ name: "AZPS", value: 0, unit: "kgCO2e/kWh" },
				{ name: "BANC", value: 0, unit: "kgCO2e/kWh" },
				{ name: "BCHYDRO", value: 0, unit: "kgCO2e/kWh" },
				{ name: "BE", value: 0, unit: "kgCO2e/kWh" },
				{ name: "BPA", value: 0, unit: "kgCO2e/kWh" },
				{ name: "CAISO", value: 0, unit: "kgCO2e/kWh" },
				{ name: "CHPD", value: 0, unit: "kgCO2e/kWh" },
				{ name: "CPLE", value: 0, unit: "kgCO2e/kWh" },
				{ name: "CPLW", value: 0, unit: "kgCO2e/kWh" },
				{ name: "CZ", value: 0, unit: "kgCO2e/kWh" },
				{ name: "DE", value: 0, unit: "kgCO2e/kWh" },
				{ name: "DK", value: 0, unit: "kgCO2e/kWh" },
				{ name: "DOPD", value: 0, unit: "kgCO2e/kWh" },
				{ name: "DUK", value: 0, unit: "kgCO2e/kWh" },
				{ name: "EE", value: 0, unit: "kgCO2e/kWh" },
				{ name: "ELE", value: 0, unit: "kgCO2e/kWh" },
				{ name: "ERCOT", value: 0, unit: "kgCO2e/kWh" },
				{ name: "ES", value: 0, unit: "kgCO2e/kWh" },
				{ name: "FI", value: 0, unit: "kgCO2e/kWh" },
				{ name: "FMPP", value: 0, unit: "kgCO2e/kWh" },
				{ name: "FPC", value: 0, unit: "kgCO2e/kWh" },
				{ name: "FPL", value: 0, unit: "kgCO2e/kWh" },
				{ name: "FR", value: 0, unit: "kgCO2e/kWh" },
				{ name: "GCPD", value: 0, unit: "kgCO2e/kWh" },
				{ name: "GR", value: 0, unit: "kgCO2e/kWh" },
				{ name: "GVL", value: 0, unit: "kgCO2e/kWh" },
				{ name: "HQ", value: 0, unit: "kgCO2e/kWh" },
				{ name: "HST", value: 0, unit: "kgCO2e/kWh" },
				{ name: "HU", value: 0, unit: "kgCO2e/kWh" },
				{ name: "IE", value: 0, unit: "kgCO2e/kWh" },
				{ name: "IESO", value: 0, unit: "kgCO2e/kWh" },
				{ name: "IID", value: 0, unit: "kgCO2e/kWh" },
				{ name: "IPCO", value: 0, unit: "kgCO2e/kWh" },
				{ name: "ISONE", value: 0, unit: "kgCO2e/kWh" },
				{ name: "IT", value: 0, unit: "kgCO2e/kWh" },
				{ name: "JEA", value: 0, unit: "kgCO2e/kWh" },
				{ name: "LDWP", value: 0, unit: "kgCO2e/kWh" },
				{ name: "LGEE", value: 0, unit: "kgCO2e/kWh" },
				{ name: "LT", value: 0, unit: "kgCO2e/kWh" },
				{ name: "LV", value: 0, unit: "kgCO2e/kWh" },
				{ name: "MISO", value: 0, unit: "kgCO2e/kWh" },
				{ name: "MPCO", value: 0, unit: "kgCO2e/kWh" },
				{ name: "NEM_NSW", value: 0, unit: "kgCO2e/kWh" },
				{ name: "NEM_QLD", value: 0, unit: "kgCO2e/kWh" },
				{ name: "NEM_SA", value: 0, unit: "kgCO2e/kWh" },
				{ name: "NEM_TAS", value: 0, unit: "kgCO2e/kWh" },
				{ name: "NEM_VIC", value: 0, unit: "kgCO2e/kWh" },
				{ name: "NEVP", value: 0, unit: "kgCO2e/kWh" },
				{ name: "NL", value: 0, unit: "kgCO2e/kWh" },
				{ name: "NO", value: 0, unit: "kgCO2e/kWh" },
				{ name: "NYISO", value: 0, unit: "kgCO2e/kWh" },
				{ name: "PACE", value: 0, unit: "kgCO2e/kWh" },
				{ name: "PACW", value: 0, unit: "kgCO2e/kWh" },
				{ name: "PGE", value: 0, unit: "kgCO2e/kWh" },
				{ name: "PJM", value: 0, unit: "kgCO2e/kWh" },
				{ name: "PL", value: 0, unit: "kgCO2e/kWh" },
				{ name: "PNM", value: 0, unit: "kgCO2e/kWh" },
				{ name: "PSCO", value: 0, unit: "kgCO2e/kWh" },
				{ name: "PSEI", value: 0, unit: "kgCO2e/kWh" },
				{ name: "PT", value: 0, unit: "kgCO2e/kWh" },
				{ name: "RO", value: 0, unit: "kgCO2e/kWh" },
				{ name: "RS", value: 0, unit: "kgCO2e/kWh" },
				{ name: "SC", value: 0, unit: "kgCO2e/kWh" },
				{ name: "SCEG", value: 0, unit: "kgCO2e/kWh" },
				{ name: "SCL", value: 0, unit: "kgCO2e/kWh" },
				{ name: "SE", value: 0, unit: "kgCO2e/kWh" },
				{ name: "SEC", value: 0, unit: "kgCO2e/kWh" },
				{ name: "SI", value: 0, unit: "kgCO2e/kWh" },
				{ name: "SK", value: 0, unit: "kgCO2e/kWh" },
				{ name: "SOCO", value: 0, unit: "kgCO2e/kWh" },
				{ name: "SPA", value: 0, unit: "kgCO2e/kWh" },
				{ name: "SPP", value: 0, unit: "kgCO2e/kWh" },
				{ name: "SRP", value: 0, unit: "kgCO2e/kWh" },
				{ name: "TAL", value: 0, unit: "kgCO2e/kWh" },
				{ name: "TEC", value: 0, unit: "kgCO2e/kWh" },
				{ name: "TEPC", value: 0, unit: "kgCO2e/kWh" },
				{ name: "TID", value: 0, unit: "kgCO2e/kWh" },
				{ name: "TPWR", value: 0, unit: "kgCO2e/kWh" },
				{ name: "TVA", value: 0, unit: "kgCO2e/kWh" },
				{ name: "UK", value: 0, unit: "kgCO2e/kWh" },
				{ name: "WACM", value: 0, unit: "kgCO2e/kWh" },
				{ name: "WALC", value: 0, unit: "kgCO2e/kWh" },
				{ name: "WAUW", value: 0, unit: "kgCO2e/kWh" },
				{ name: "WEM", value: 0, unit: "kgCO2e/kWh" }
			]
		}
	]
};
